function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15252_204291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6479 14.9507C14.2234 16.0365 12.4888 16.6381 10.6979 16.6673C4.86458 16.6673 1.53125 10.0007 1.53125 10.0007C2.56782 8.06892 4.00553 6.38118 5.74792 5.05067M8.94792 3.53401C9.52153 3.39974 10.1088 3.33262 10.6979 3.33401C16.5313 3.33401 19.8646 10.0007 19.8646 10.0007C19.3587 10.947 18.7555 11.838 18.0646 12.659M12.4646 11.7673C12.2357 12.013 11.9597 12.21 11.653 12.3466C11.3464 12.4832 11.0153 12.5567 10.6797 12.5626C10.344 12.5686 10.0106 12.5068 9.69926 12.3811C9.38796 12.2553 9.10518 12.0682 8.86779 11.8308C8.63039 11.5934 8.44324 11.3106 8.31751 10.9993C8.19177 10.688 8.13002 10.3546 8.13594 10.0189C8.14187 9.68325 8.21534 9.35221 8.35198 9.04554C8.48862 8.73888 8.68563 8.46288 8.93125 8.23401",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53125 0.833984L19.8646 19.1673",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15252_204291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.695312)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.3f753d971876041ee1091edc521469c3.svg";
export { ForwardRef as ReactComponent };